[
  {
    "code": "DZ",
    "country": "Algeria",
    "region": "Africa"
  },
  {
    "code": "AO",
    "country": "Angola",
    "region": "Africa"
  },
  {
    "code": "BJ",
    "country": "Benin",
    "region": "Africa"
  },
  {
    "code": "BW",
    "country": "Botswana",
    "region": "Africa"
  },
  {
    "code": "BF",
    "country": "Burkina Faso",
    "region": "Africa"
  },
  {
    "code": "BI",
    "country": "Burundi",
    "region": "Africa"
  },
  {
    "code": "CV",
    "country": "Cabo Verde",
    "region": "Africa"
  },
  {
    "code": "CM",
    "country": "Cameroon",
    "region": "Africa"
  },
  {
    "code": "CF",
    "country": "Central African Republic",
    "region": "Africa"
  },
  {
    "code": "TD",
    "country": "Chad",
    "region": "Africa"
  },
  {
    "code": "KM",
    "country": "Comoros ",
    "region": "Africa"
  },
  {
    "code": "CD",
    "country": "Congo",
    "region": "Africa"
  },
  {
    "code": "CG",
    "country": "Congo",
    "region": "Africa"
  },
  {
    "code": "CI",
    "country": "Côte d'Ivoire",
    "region": "Africa"
  },
  {
    "code": "DJ",
    "country": "Djibouti",
    "region": "Africa"
  },
  {
    "code": "EG",
    "country": "Egypt",
    "region": "Africa"
  },
  {
    "code": "GQ",
    "country": "Equatorial Guinea",
    "region": "Africa"
  },
  {
    "code": "ER",
    "country": "Eritrea",
    "region": "Africa"
  },
  {
    "code": "ET",
    "country": "Ethiopia",
    "region": "Africa"
  },
  {
    "code": "GA",
    "country": "Gabon",
    "region": "Africa"
  },
  {
    "code": "GM",
    "country": "Gambia ",
    "region": "Africa"
  },
  {
    "code": "GH",
    "country": "Ghana",
    "region": "Africa"
  },
  {
    "code": "GN",
    "country": "Guinea",
    "region": "Africa"
  },
  {
    "code": "GW",
    "country": "Guinea-Bissau",
    "region": "Africa"
  },
  {
    "code": "KE",
    "country": "Kenya",
    "region": "Africa"
  },
  {
    "code": "LS",
    "country": "Lesotho",
    "region": "Africa"
  },
  {
    "code": "LR",
    "country": "Liberia",
    "region": "Africa"
  },
  {
    "code": "LY",
    "country": "Libya",
    "region": "Africa"
  },
  {
    "code": "MG",
    "country": "Madagascar",
    "region": "Africa"
  },
  {
    "code": "MW",
    "country": "Malawi",
    "region": "Africa"
  },
  {
    "code": "ML",
    "country": "Mali",
    "region": "Africa"
  },
  {
    "code": "MR",
    "country": "Mauritania",
    "region": "Africa"
  },
  {
    "code": "MU",
    "country": "Mauritius",
    "region": "Africa"
  },
  {
    "code": "YT",
    "country": "Mayotte",
    "region": "Africa"
  },
  {
    "code": "MA",
    "country": "Morocco",
    "region": "Africa"
  },
  {
    "code": "MZ",
    "country": "Mozambique",
    "region": "Africa"
  },
  {
    "code": "NA",
    "country": "Namibia",
    "region": "Africa"
  },
  {
    "code": "NE",
    "country": "Niger",
    "region": "Africa"
  },
  {
    "code": "NG",
    "country": "Nigeria",
    "region": "Africa"
  },
  {
    "code": "RE",
    "country": "Réunion",
    "region": "Africa"
  },
  {
    "code": "RW",
    "country": "Rwanda",
    "region": "Africa"
  },
  {
    "code": "SH",
    "country": "Saint Helena, Ascension and Tristan da Cunha",
    "region": "Africa"
  },
  {
    "code": "ST",
    "country": "Sao Tome and Principe",
    "region": "Africa"
  },
  {
    "code": "SN",
    "country": "Senegal",
    "region": "Africa"
  },
  {
    "code": "SC",
    "country": "Seychelles",
    "region": "Africa"
  },
  {
    "code": "SL",
    "country": "Sierra Leone",
    "region": "Africa"
  },
  {
    "code": "SO",
    "country": "Somalia",
    "region": "Africa"
  },
  {
    "code": "ZA",
    "country": "South Africa",
    "region": "Africa"
  },
  {
    "code": "SS",
    "country": "South Sudan",
    "region": "Africa"
  },
  {
    "code": "SD",
    "country": "Sudan ",
    "region": "Africa"
  },
  {
    "code": "SZ",
    "country": "Swaziland",
    "region": "Africa"
  },
  {
    "code": "TZ",
    "country": "Tanzania, United Republic of",
    "region": "Africa"
  },
  {
    "code": "TG",
    "country": "Togo",
    "region": "Africa"
  },
  {
    "code": "TN",
    "country": "Tunisia",
    "region": "Africa"
  },
  {
    "code": "UG",
    "country": "Uganda",
    "region": "Africa"
  },
  {
    "code": "EH",
    "country": "Western Sahara*",
    "region": "Africa"
  },
  {
    "code": "ZM",
    "country": "Zambia",
    "region": "Africa"
  },
  {
    "code": "ZW",
    "country": "Zimbabwe",
    "region": "Africa"
  },
  {
    "code": "AQ",
    "country": "Antarctica",
    "region": "Antarctic"
  },
  {
    "code": "BV",
    "country": "Bouvet Island",
    "region": "Antarctic"
  },
  {
    "code": "TF",
    "country": "French Southern Territories",
    "region": "Antarctic"
  },
  {
    "code": "HM",
    "country": "Heard Island and McDonald Islands",
    "region": "Antarctic"
  },
  {
    "code": "GS",
    "country": "South Georgia and the South Sandwich Islands",
    "region": "Antarctic"
  },
  {
    "code": "AF",
    "country": "Afghanistan",
    "region": "Asia"
  },
  {
    "code": "AM",
    "country": "Armenia",
    "region": "Asia"
  },
  {
    "code": "AZ",
    "country": "Azerbaijan",
    "region": "Asia"
  },
  {
    "code": "BD",
    "country": "Bangladesh",
    "region": "Asia"
  },
  {
    "code": "BT",
    "country": "Bhutan",
    "region": "Asia"
  },
  {
    "code": "IO",
    "country": "British Indian Ocean Territory",
    "region": "Asia"
  },
  {
    "code": "BN",
    "country": "Brunei Darussalam",
    "region": "Asia"
  },
  {
    "code": "KH",
    "country": "Cambodia",
    "region": "Asia"
  },
  {
    "code": "CN",
    "country": "China",
    "region": "Asia"
  },
  {
    "code": "GE",
    "country": "Georgia",
    "region": "Asia"
  },
  {
    "code": "HK",
    "country": "Hong Kong",
    "region": "Asia"
  },
  {
    "code": "IN",
    "country": "India",
    "region": "Asia"
  },
  {
    "code": "ID",
    "country": "Indonesia",
    "region": "Asia"
  },
  {
    "code": "JP",
    "country": "Japan",
    "region": "Asia"
  },
  {
    "code": "KZ",
    "country": "Kazakhstan",
    "region": "Asia"
  },
  {
    "code": "KP",
    "country": "North Korea",
    "region": "Asia"
  },
  {
    "code": "KR",
    "country": "South Korea",
    "region": "Asia"
  },
  {
    "code": "KG",
    "country": "Kyrgyzstan",
    "region": "Asia"
  },
  {
    "code": "LA",
    "country": "Lao People's Democratic Republic",
    "region": "Asia"
  },
  {
    "code": "MO",
    "country": "Macao",
    "region": "Asia"
  },
  {
    "code": "MY",
    "country": "Malaysia",
    "region": "Asia"
  },
  {
    "code": "MV",
    "country": "Maldives",
    "region": "Asia"
  },
  {
    "code": "MN",
    "country": "Mongolia",
    "region": "Asia"
  },
  {
    "code": "MM",
    "country": "Myanmar",
    "region": "Asia"
  },
  {
    "code": "NP",
    "country": "Nepal",
    "region": "Asia"
  },
  {
    "code": "PK",
    "country": "Pakistan",
    "region": "Asia"
  },
  {
    "code": "PH",
    "country": "Philippines",
    "region": "Asia"
  },
  {
    "code": "SG",
    "country": "Singapore",
    "region": "Asia"
  },
  {
    "code": "LK",
    "country": "Sri Lanka",
    "region": "Asia"
  },
  {
    "code": "TW",
    "country": "Taiwan",
    "region": "Asia"
  },
  {
    "code": "TJ",
    "country": "Tajikistan",
    "region": "Asia"
  },
  {
    "code": "TH",
    "country": "Thailand",
    "region": "Asia"
  },
  {
    "code": "TL",
    "country": "Timor-Leste",
    "region": "Asia"
  },
  {
    "code": "TM",
    "country": "Turkmenistan",
    "region": "Asia"
  },
  {
    "code": "UZ",
    "country": "Uzbekistan",
    "region": "Asia"
  },
  {
    "code": "VN",
    "country": "Vietnam",
    "region": "Asia"
  },
  {
    "code": "BZ",
    "country": "Belize",
    "region": "Central America"
  },
  {
    "code": "CR",
    "country": "Costa Rica",
    "region": "Central America"
  },
  {
    "code": "SV",
    "country": "El Salvador",
    "region": "Central America"
  },
  {
    "code": "GT",
    "country": "Guatemala",
    "region": "Central America"
  },
  {
    "code": "HN",
    "country": "Honduras",
    "region": "Central America"
  },
  {
    "code": "MX",
    "country": "Mexico",
    "region": "Central America"
  },
  {
    "code": "NI",
    "country": "Nicaragua",
    "region": "Central America"
  },
  {
    "code": "PA",
    "country": "Panama",
    "region": "Central America"
  },
  {
    "code": "AX",
    "country": "Åland Islands",
    "region": "Europe"
  },
  {
    "code": "AL",
    "country": "Albania",
    "region": "Europe"
  },
  {
    "code": "AD",
    "country": "Andorra",
    "region": "Europe"
  },
  {
    "code": "AT",
    "country": "Austria",
    "region": "Europe"
  },
  {
    "code": "BY",
    "country": "Belarus",
    "region": "Europe"
  },
  {
    "code": "BE",
    "country": "Belgium",
    "region": "Europe"
  },
  {
    "code": "BA",
    "country": "Bosnia and Herzegovina",
    "region": "Europe"
  },
  {
    "code": "BG",
    "country": "Bulgaria",
    "region": "Europe"
  },
  {
    "code": "HR",
    "country": "Croatia",
    "region": "Europe"
  },
  {
    "code": "CY",
    "country": "Cyprus",
    "region": "Europe"
  },
  {
    "code": "CZ",
    "country": "Czechia",
    "region": "Europe"
  },
  {
    "code": "DK",
    "country": "Denmark",
    "region": "Europe"
  },
  {
    "code": "EE",
    "country": "Estonia",
    "region": "Europe"
  },
  {
    "code": "EU",
    "country": "Europe",
    "region": "Europe"
  },
  {
    "code": "FO",
    "country": "Faroe Islands",
    "region": "Europe"
  },
  {
    "code": "FI",
    "country": "Finland",
    "region": "Europe"
  },
  {
    "code": "FR",
    "country": "France",
    "region": "Europe"
  },
  {
    "code": "DE",
    "country": "Germany",
    "region": "Europe"
  },
  {
    "code": "GI",
    "country": "Gibraltar",
    "region": "Europe"
  },
  {
    "code": "GR",
    "country": "Greece",
    "region": "Europe"
  },
  {
    "code": "GG",
    "country": "Guernsey",
    "region": "Europe"
  },
  {
    "code": "VA",
    "country": "Holy See",
    "region": "Europe"
  },
  {
    "code": "HU",
    "country": "Hungary",
    "region": "Europe"
  },
  {
    "code": "IS",
    "country": "Iceland",
    "region": "Europe"
  },
  {
    "code": "IE",
    "country": "Ireland",
    "region": "Europe"
  },
  {
    "code": "IM",
    "country": "Isle of Man",
    "region": "Europe"
  },
  {
    "code": "IT",
    "country": "Italy",
    "region": "Europe"
  },
  {
    "code": "XK",
    "country": "Kosovo",
    "region": "Europe"
  },
  {
    "code": "JE",
    "country": "Jersey",
    "region": "Europe"
  },
  {
    "code": "LV",
    "country": "Latvia",
    "region": "Europe"
  },
  {
    "code": "LI",
    "country": "Liechtenstein",
    "region": "Europe"
  },
  {
    "code": "LT",
    "country": "Lithuania",
    "region": "Europe"
  },
  {
    "code": "LU",
    "country": "Luxembourg",
    "region": "Europe"
  },
  {
    "code": "MT",
    "country": "Malta",
    "region": "Europe"
  },
  {
    "code": "MD",
    "country": "Moldova",
    "region": "Europe"
  },
  {
    "code": "MC",
    "country": "Monaco",
    "region": "Europe"
  },
  {
    "code": "ME",
    "country": "Montenegro",
    "region": "Europe"
  },
  {
    "code": "NL",
    "country": "Netherlands",
    "region": "Europe"
  },
  {
    "code": "MK",
    "country": "North Macedonia",
    "region": "Europe"
  },
  {
    "code": "NO",
    "country": "Norway",
    "region": "Europe"
  },
  {
    "code": "PL",
    "country": "Poland",
    "region": "Europe"
  },
  {
    "code": "PT",
    "country": "Portugal",
    "region": "Europe"
  },
  {
    "code": "RO",
    "country": "Romania",
    "region": "Europe"
  },
  {
    "code": "RU",
    "country": "Russian Federation",
    "region": "Europe"
  },
  {
    "code": "SM",
    "country": "San Marino",
    "region": "Europe"
  },
  {
    "code": "RS",
    "country": "Serbia",
    "region": "Europe"
  },
  {
    "code": "SK",
    "country": "Slovakia",
    "region": "Europe"
  },
  {
    "code": "SI",
    "country": "Slovenia",
    "region": "Europe"
  },
  {
    "code": "ES",
    "country": "Spain",
    "region": "Europe"
  },
  {
    "code": "SJ",
    "country": "Svalbard and Jan Mayen",
    "region": "Europe"
  },
  {
    "code": "SE",
    "country": "Sweden",
    "region": "Europe"
  },
  {
    "code": "CH",
    "country": "Switzerland",
    "region": "Europe"
  },
  {
    "code": "TR",
    "country": "Turkey",
    "region": "Europe"
  },
  {
    "code": "UA",
    "country": "Ukraine",
    "region": "Europe"
  },
  {
    "code": "GB",
    "country": "United Kingdom of Great Britain and Northern Ireland",
    "region": "Europe"
  },
  {
    "code": "BH",
    "country": "Bahrain",
    "region": "Middle East"
  },
  {
    "code": "IR",
    "country": "Iran",
    "region": "Middle East"
  },
  {
    "code": "IQ",
    "country": "Iraq",
    "region": "Middle East"
  },
  {
    "code": "IL",
    "country": "Israel",
    "region": "Middle East"
  },
  {
    "code": "JO",
    "country": "Jordan",
    "region": "Middle East"
  },
  {
    "code": "KW",
    "country": "Kuwait",
    "region": "Middle East"
  },
  {
    "code": "LB",
    "country": "Lebanon",
    "region": "Middle East"
  },
  {
    "code": "OM",
    "country": "Oman",
    "region": "Middle East"
  },
  {
    "code": "PS",
    "country": "Palestine, State of",
    "region": "Middle East"
  },
  {
    "code": "QA",
    "country": "Qatar",
    "region": "Middle East"
  },
  {
    "code": "SA",
    "country": "Saudi Arabia",
    "region": "Middle East"
  },
  {
    "code": "SY",
    "country": "Syrian Arab Republic",
    "region": "Middle East"
  },
  {
    "code": "AE",
    "country": "United Arab Emirates",
    "region": "Middle East"
  },
  {
    "code": "YE",
    "country": "Yemen",
    "region": "Middle East"
  },
  {
    "code": "BM",
    "country": "Bermuda",
    "region": "North America"
  },
  {
    "code": "CA",
    "country": "Canada",
    "region": "North America"
  },
  {
    "code": "GL",
    "country": "Greenland",
    "region": "North America"
  },
  {
    "code": "PM",
    "country": "Saint Pierre and Miquelon",
    "region": "North America"
  },
  {
    "code": "US",
    "country": "United States of America",
    "region": "North America"
  },
  {
    "code": "AS",
    "country": "American Samoa",
    "region": "Oceania"
  },
  {
    "code": "AU",
    "country": "Australia",
    "region": "Oceania"
  },
  {
    "code": "CX",
    "country": "Christmas Island",
    "region": "Oceania"
  },
  {
    "code": "CC",
    "country": "Cocos Islands (the)",
    "region": "Oceania"
  },
  {
    "code": "CK",
    "country": "Cook Islands",
    "region": "Oceania"
  },
  {
    "code": "FJ",
    "country": "Fiji",
    "region": "Oceania"
  },
  {
    "code": "PF",
    "country": "French Polynesia",
    "region": "Oceania"
  },
  {
    "code": "GU",
    "country": "Guam",
    "region": "Oceania"
  },
  {
    "code": "KI",
    "country": "Kiribati",
    "region": "Oceania"
  },
  {
    "code": "MH",
    "country": "Marshall Islands",
    "region": "Oceania"
  },
  {
    "code": "FM",
    "country": "Micronesia",
    "region": "Oceania"
  },
  {
    "code": "NR",
    "country": "Nauru",
    "region": "Oceania"
  },
  {
    "code": "NC",
    "country": "New Caledonia",
    "region": "Oceania"
  },
  {
    "code": "NZ",
    "country": "New Zealand",
    "region": "Oceania"
  },
  {
    "code": "NU",
    "country": "Niue",
    "region": "Oceania"
  },
  {
    "code": "NF",
    "country": "Norfolk Island",
    "region": "Oceania"
  },
  {
    "code": "MP",
    "country": "Northern Mariana Islands",
    "region": "Oceania"
  },
  {
    "code": "PW",
    "country": "Palau",
    "region": "Oceania"
  },
  {
    "code": "PG",
    "country": "Papua New Guinea",
    "region": "Oceania"
  },
  {
    "code": "PN",
    "country": "Pitcairn",
    "region": "Oceania"
  },
  {
    "code": "WS",
    "country": "Samoa",
    "region": "Oceania"
  },
  {
    "code": "SB",
    "country": "Solomon Islands",
    "region": "Oceania"
  },
  {
    "code": "TK",
    "country": "Tokelau",
    "region": "Oceania"
  },
  {
    "code": "TO",
    "country": "Tonga",
    "region": "Oceania"
  },
  {
    "code": "TV",
    "country": "Tuvalu",
    "region": "Oceania"
  },
  {
    "code": "UM",
    "country": "United States Minor Outlying Islands",
    "region": "Oceania"
  },
  {
    "code": "VU",
    "country": "Vanuatu",
    "region": "Oceania"
  },
  {
    "code": "WF",
    "country": "Wallis and Futuna",
    "region": "Oceania"
  },
  {
    "code": "AR",
    "country": "Argentina",
    "region": "South America"
  },
  {
    "code": "BO",
    "country": "Bolivia",
    "region": "South America"
  },
  {
    "code": "BR",
    "country": "Brazil",
    "region": "South America"
  },
  {
    "code": "CL",
    "country": "Chile",
    "region": "South America"
  },
  {
    "code": "CO",
    "country": "Colombia",
    "region": "South America"
  },
  {
    "code": "EC",
    "country": "Ecuador",
    "region": "South America"
  },
  {
    "code": "FK",
    "country": "Falkland Islands",
    "region": "South America"
  },
  {
    "code": "GF",
    "country": "French Guiana",
    "region": "South America"
  },
  {
    "code": "GY",
    "country": "Guyana",
    "region": "South America"
  },
  {
    "code": "PY",
    "country": "Paraguay",
    "region": "South America"
  },
  {
    "code": "PE",
    "country": "Peru",
    "region": "South America"
  },
  {
    "code": "SR",
    "country": "Suriname",
    "region": "South America"
  },
  {
    "code": "UY",
    "country": "Uruguay",
    "region": "South America"
  },
  {
    "code": "VE",
    "country": "Venezuela",
    "region": "South America"
  },
  {
    "code": "AI",
    "country": "Anguilla",
    "region": "The Caribbean"
  },
  {
    "code": "AG",
    "country": "Antigua and Barbuda",
    "region": "The Caribbean"
  },
  {
    "code": "AW",
    "country": "Aruba",
    "region": "The Caribbean"
  },
  {
    "code": "BS",
    "country": "Bahamas",
    "region": "The Caribbean"
  },
  {
    "code": "BB",
    "country": "Barbados",
    "region": "The Caribbean"
  },
  {
    "code": "BQ",
    "country": "Bonaire, Sint Eustatius and Saba",
    "region": "The Caribbean"
  },
  {
    "code": "KY",
    "country": "Cayman Islands",
    "region": "The Caribbean"
  },
  {
    "code": "CU",
    "country": "Cuba",
    "region": "The Caribbean"
  },
  {
    "code": "CW",
    "country": "Curaçao",
    "region": "The Caribbean"
  },
  {
    "code": "DM",
    "country": "Dominica",
    "region": "The Caribbean"
  },
  {
    "code": "DO",
    "country": "Dominican Republic",
    "region": "The Caribbean"
  },
  {
    "code": "GD",
    "country": "Grenada",
    "region": "The Caribbean"
  },
  {
    "code": "GP",
    "country": "Guadeloupe",
    "region": "The Caribbean"
  },
  {
    "code": "HT",
    "country": "Haiti",
    "region": "The Caribbean"
  },
  {
    "code": "JM",
    "country": "Jamaica",
    "region": "The Caribbean"
  },
  {
    "code": "MQ",
    "country": "Martinique",
    "region": "The Caribbean"
  },
  {
    "code": "MS",
    "country": "Montserrat",
    "region": "The Caribbean"
  },
  {
    "code": "AN",
    "country": "Netherlands Antilles",
    "region": "The Caribbean"
  },
  {
    "code": "PR",
    "country": "Puerto Rico",
    "region": "The Caribbean"
  },
  {
    "code": "BL",
    "country": "Saint Barthélemy",
    "region": "The Caribbean"
  },
  {
    "code": "KN",
    "country": "Saint Kitts and Nevis",
    "region": "The Caribbean"
  },
  {
    "code": "LC",
    "country": "Saint Lucia",
    "region": "The Caribbean"
  },
  {
    "code": "MF",
    "country": "Saint Martin",
    "region": "The Caribbean"
  },
  {
    "code": "VC",
    "country": "Saint Vincent and the Grenadines",
    "region": "The Caribbean"
  },
  {
    "code": "SX",
    "country": "Sint Maarten",
    "region": "The Caribbean"
  },
  {
    "code": "TT",
    "country": "Trinidad and Tobago",
    "region": "The Caribbean"
  },
  {
    "code": "TC",
    "country": "Turks and Caicos Islands",
    "region": "The Caribbean"
  },
  {
    "code": "VG",
    "country": "Virgin Islands",
    "region": "The Caribbean"
  },
  {
    "code": "VI",
    "country": "British Virgin Islands",
    "region": "The Caribbean"
  }
]
